/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function createMagicToken({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
    "x-agency-id": store.getters['agency/currentAgencyId'],
  };

  return axios.post("/tokens", payload, { headers });
}

export function getMagicToken({ token }) {
  return axios.get(`/tokens/${token}`);
}

export function fulfillMagicToken({ token, accessToken, payload }) {
  const headers ={
    "Content-Type": "application/json",
    "x-access-token": accessToken
  };

  return axios.put(`/tokens/${token}`, payload, { headers });
}

export function getMagicTokenQRCode({ token }) {
  return axios.get(`/tokens/${token}/qrcode`);
}
